export default __webpack_public_path__ + "static/media/IC.89741990.gif";